export default __webpack_public_path__ + "static/media/information--stairs--g4.64156853.png";